const { withNormalization } = require('./utils/normalization');
const { validator } = require('./utils/validation');

module.exports = withNormalization({
  // Avoid duplicated RegExp compilation
  normalize: rule => ({
    ...rule,
    pattern: new RegExp(rule.pattern)
  }),

  test({ rule, params }) {
    const param = params[rule.parameter];
    if (param == null) {   // intentionally match null and undefined
      return false;
    }

    return rule.pattern.test(String(param));
  },

  validate: validator({
    '`parameter` property is required': rule => 'parameter' in rule,
    '`pattern` property is required': rule => 'pattern' in rule,
    '`parameter` must be a string': rule => typeof rule.parameter === 'string',
    '`pattern` must be a string': rule => typeof rule.pattern === 'string'
  })
});
